import { z } from 'zod';
import { CrewClaimResolutionMethodEnum } from '../../enums/crew.js';
export const requestedResolutionMethodUnion = z.union([
    z.literal(`${CrewClaimResolutionMethodEnum.refund}`),
    z.literal(`${CrewClaimResolutionMethodEnum.giftCard}`),
    z.literal(`${CrewClaimResolutionMethodEnum.variantExchange}`),
    z.literal(`${CrewClaimResolutionMethodEnum.warrantyReview}`),
]);
//# sourceMappingURL=requestedResolutionMethod.js.map